import React from 'react';
import type { VariantProps } from '@gluestack-ui/nativewind-utils';

import { hstackStyle } from './styles';

import { toDomStyle } from '@/util/domStyle';
import { translateRnA11yProps, type RnAccessibilityProps } from '@/util/accessibilityProps';

type IHStackProps = React.ComponentPropsWithoutRef<'div'> &
  VariantProps<typeof hstackStyle> &
  RnAccessibilityProps & {
    testID?: string;
  };

const HStack = React.forwardRef<React.ElementRef<'div'>, IHStackProps>(
  ({ className, space, reversed, testID, style, ...props }, ref) => {
    const { rest, aria } = translateRnA11yProps(props as Record<string, unknown>);

    return (
      <div
        className={hstackStyle({ space, reversed, class: className })}
        data-testid={testID}
        {...rest}
        {...aria}
        style={toDomStyle(style)}
        ref={ref}
      />
    );
  }
);

HStack.displayName = 'HStack';

export { HStack };
